import React, { useEffect, useState } from 'react';
import { BreadCrumb, CardLayout, ListLayout } from '../../containers/Layout';
import { isEmpty } from 'lodash';
import Currency from '../../../../../commonModules/Currency.jsx';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import { TableCell, TableHead, TableBody, TableRow, IconButton, Box } from '@material-ui/core';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import { AddRounded, DeleteRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';
import SingleProduct from '../../products/SingleProduct';
import SingleShop from '../../shops/SingleShop';
import { useSelector } from 'react-redux';
import SingleTransferReturnProduct from './SingleTransferReturnProduct';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';

const ListTransferReturn = (props) => {
    const SHOPS = useSelector((state) => state.inventory.shops); 
    const PRODUCTS = useSelector((state) => state.inventory.products); 
    const RETURNS = useSelector((state) => state.inventory.returns); 
    const PAYG_CLIENTS = useSelector((state) => state.clients); 
    const fetchTransfers = useFetchTransfers("occasion");

    const [state, setState] = useState({
        headerMenu: 'STOCK',
        search: '',
        searchClass: 'custom-search',
        sortQTy: 'asc',
        deletePopup: false,
        details: false,
        product: {},
    });

    useEffect(() => {
        console.log("MOUNTING ListTransferReturn");
        if(isEmpty(RETURNS)){
            fetchTransfers();
        }
    }, []);

    
    const normalizeStr = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    };

    const createProductList = () => {
        const { search } = state;

        let searching = search ? normalizeStr(search) : '';
        let list = Object.values(RETURNS);

        let filteredList = list.filter((prod) => {
            const productName = normalizeStr(PRODUCTS[prod.product_ref].name);
            const productRef = normalizeStr(PRODUCTS[prod.product_ref].ref);
            const productType = normalizeStr(PRODUCTS[prod.product_ref].type);
            const productBrand = normalizeStr(PRODUCTS[prod.product_ref].marque);
            const shopName = normalizeStr(SHOPS[prod.product_location].name);
            const shopCity = normalizeStr(SHOPS[prod.product_location].city);
            const shopCountry = normalizeStr(SHOPS[prod.product_location].country);

            if (!searching) {
                return true;
            } else {
                return (
                    productName.indexOf(searching) !== -1 ||
                    productRef.indexOf(searching) !== -1 ||
                    productType.indexOf(searching) !== -1 ||
                    productBrand.indexOf(searching) !== -1 ||
                    shopName.indexOf(searching) !== -1 ||
                    shopCity.indexOf(searching) !== -1 ||
                    shopCountry.indexOf(searching) !== -1
                );
            }
        });

        filteredList = filteredList.sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date));

        return filteredList.map((prod) => (
            <TableRow key={prod.id}>
                <TableCell>{new Date(new Date(prod.update_date).getFullYear() !== 1 ? prod.update_date : prod.creation_date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell>{prod.id.substring(0, 8)}</TableCell>
                <TableCell>
                <a href="#" title="Voir la fiche produit" onClick={() => props.handleSingleProd(PRODUCTS[prod.product_ref])}>
                    {PRODUCTS[prod.product_ref].name} - {PRODUCTS[prod.product_ref].marque}
                </a>
                </TableCell>
                <TableCell>
                <a href="#" title="Voir la fiche magasin" onClick={() => props.handleSingleShop(SHOPS[prod.product_location])}>
                    {SHOPS[prod.product_location].name}
                </a>
                </TableCell>
                <TableCell>{prod.product_quantity_initial}</TableCell>
                <TableCell>
                <Currency value={prod.sell_price} />
                </TableCell>
                <TableCell>
                <IconButton color="secondary" onClick={() => handleDetails(prod)}>
                    <AddRounded />
                </IconButton>
                </TableCell>
                <TableCell>
                <IconButton onClick={() => handleDelete(prod)}>
                    <DeleteRounded color="error" />
                </IconButton>
                </TableCell>
            </TableRow>
            ));
        };

        const handleDetails = (prod) => {
            setState({
                ...state,
                details: true,
                product: prod,
            });
        };

        const handleClosePopUp = () => {
            setState({
                ...state,
                details: false,
                product: {},
            });
        };

        const handleDelete = (prod) => {
            setState({
                ...state,
                deletePopup: true,
                product: prod,
            });
        };

        const deleteProduct = async () => {
            props
            .deleteReturnProduct(state.product.id)
            .then(() => {
                toast.success('Produit supprimé');
                setState({
                ...state,
                deletePopup: false,
                product: {},
                });
            })
            .catch((e) => {
                toast.error('ERROR ' + JSON.stringify(e));
            });
        };

  return (
        <div>
            <BreadCrumb breadcrumb={props.breadcrumb} title="Entrées" back={props.handleClose} />
            {state.deletePopup && !isEmpty(state.product) && (
                <DeleteDialog title={' le produit n°' + state.product.id} handleSubmit={deleteProduct} close={() => setState({ ...state, deletePopup: false })} open={true} />
            )}
            {state.details && !isEmpty(state.product) && (
                <SingleTransferReturnProduct
                    product={PRODUCTS[state.product.product_ref]}
                    returnProd={state.product}
                    handleClose={handleClosePopUp}
                    client={PAYG_CLIENTS[state.product.client_ref]}
                    saleInfo={{}}
                />
            )}
            {props.showSingleShop && <SingleShop shop={props.singleShop} {...props} occasion />}
            {props.showSingleProd && <SingleProduct product={props.singleProd} {...props} occasion />}
            {!props.showSingleShop && !props.showSingleProd && (
                <Box>
                    <InputText 
                        type="text" 
                        name="search" 
                        value={state.search} 
                        placeholder="Rechercher par magasin, produit, marque ..." 
                        onChange={(e) => setState({ ...state, search: e.target.value })} 
                    />

                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date du Retour</TableCell>
                                <TableCell>Id retour</TableCell>
                                <TableCell>Produit</TableCell>
                                <TableCell>Shop</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>Prix de Vente</TableCell>
                                <TableCell>Details</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{!isEmpty(RETURNS) && createProductList()}</TableBody>
                    </ListLayout>
                </Box>
            )}
        </div>
    );
};

export default ListTransferReturn;
